import React from 'react';
import { AlertCircle } from 'lucide-react';
import './ExpiryRenewals.css';

const ExpiryRenewals: React.FC = () => {
  return (
    <div className="admin-certifi-expiry-renewals">
      <div className="admin-certifi-empty-state">
        <div className="admin-certifi-empty-icon">
          <AlertCircle size={48} />
        </div>
        <h3>No Expiring Certifications</h3>
        <p>There are currently no certifications expiring soon. Check back later.</p>
      </div>
    </div>
  );
};

export default ExpiryRenewals;
